'use client';

import { cn } from '@/lib/utils';
import { Activity, useState } from 'react';
import GamelinePanel from './table/GamelinePanel';
import ExactScorePanel from './table/ExactScorePanel';
import HalftimePanel from './table/HalftimePanel';
import { useTranslation } from '@/lib/i18n';

export interface WorldCupDataTableProps {
  eventSlug: string;
  className?: string;
}
const tabs = [
  { label: 'Game Lines', value: 'game-lines' },
  { label: 'Exact Score', value: 'exact-score' },
  { label: 'Halftime Result', value: 'halftime' },
];

export default function WorldCupDataTabs({ eventSlug, className }: WorldCupDataTableProps) {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(tabs[0].value);
  return (
    <section
      className={cn('w-full text-white', className)}
      style={{ fontFamily: "'SF Pro', -apple-system, BlinkMacSystemFont, sans-serif" }}
    >
      <div className="mb-4 flex flex-wrap items-center gap-4">
        {tabs.map((tab) => (
          <button
            key={tab.label}
            type="button"
            className={cn(
              'h-10 whitespace-nowrap text-lg leading-5 transition-colors',
              tab.value === activeTab
                ? 'font-semibold text-white'
                : 'font-normal text-[#757575] hover:text-white',
            )}
            onClick={() => setActiveTab(tab.value)}
          >
            {t(tab.label)}
          </button>
        ))}
      </div>
      <Activity mode={activeTab === 'game-lines' ? 'visible' : 'hidden'}>
        <GamelinePanel eventSlug={eventSlug} />
      </Activity>
      <Activity mode={activeTab === 'exact-score' ? 'visible' : 'hidden'}>
        <ExactScorePanel eventSlug={eventSlug} />
      </Activity>
      <Activity mode={activeTab === 'halftime' ? 'visible' : 'hidden'}>
        <HalftimePanel eventSlug={eventSlug} />
      </Activity>
    </section>
  );
}
